import { Component, input, OnInit, output, signal } from '@angular/core';

export interface RangeType {
    min: number;
    max: number;
}

@Component({
    selector: 'app-doubleslider1',
    templateUrl: './doubleslider.component.html',
    styleUrls: ['./doubleslider.component.scss'],
    standalone: false
})
export class DoublesliderComponent implements OnInit {
    minValue = input<number>(0);
    maxValue = input<number>(10000);
    step = input<number>(50);
    currency = input<string>('EUR');
    output = output<RangeType>();

    min = signal<number>(0);
    minValue_t = signal<number>(0);
    maxValue_t = signal<number>(10000);
    max = signal<number>(10000);

    minPercent = signal<number>(0);
    maxPercent = signal<number>(0);
    rangeWidth = signal<number>(0);



    constructor() { }

    ngOnInit(): void {
        this.minValue_t.set(this.minValue() ? this.minValue() : this.min());
        this.maxValue_t.set(this.maxValue() ? this.maxValue() : this.max());
        this.updateRange(this.minValue_t(), this.maxValue_t());
    }

    updateRange(tminValue, tmaxValue) {
        this.minValue_t.set(tminValue);
        this.maxValue_t.set(tmaxValue);
        if (this.minValue_t() > this.max() - this.step()) {
            this.minValue_t.set(this.max() - this.step());
        }

        if (this.maxValue_t() < this.min() + this.step()) {
            this.maxValue_t.set(this.min() + this.step());
        }

        this.minPercent.set((this.minValue_t() / this.max()) * 100);
        this.maxPercent.set((this.maxValue_t() / this.max()) * 100);
        this.rangeWidth.set(this.maxPercent() - this.minPercent());

    }

    async sendValue() {
        this.output.emit({ min: this.minValue_t(), max: (this.maxValue_t() === this.max() ? null : this.maxValue_t()) });
    }
}
